import React from 'react';
import { whatsappLink } from '../data/mock';

const SectionLabel = ({ children }) => (
  <div className="inline-flex items-center gap-2 text-cream-soft text-[13px] tracking-[0.25em] uppercase">
    <span className="text-cream/70">✦</span>
    <span>{children}</span>
  </div>
);

const About = () => {
  return (
    <section id="conceito" className="relative py-24 md:py-32">
      <div className="max-w-6xl mx-auto px-6">
        <SectionLabel>A BRN Barbearia</SectionLabel>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-end">
          <h2 className="md:col-span-7 font-display text-[40px] sm:text-[54px] md:text-[68px] leading-[1.05] text-cream">
            Elevar o padrão<br />
            <span className="text-cream/55">do que significa cortar cabelo.</span>
          </h2>

          <div className="md:col-span-5 space-y-5 text-cream-soft text-[15px] md:text-[16px] leading-relaxed">
            <p>
              Fundada em Jundiaí, a BRN surgiu da inquietação de fazer diferente. Em um mercado onde muitos
              entregam o básico, decidimos construir algo acima da média: estrutura organizada, atendimento
              padronizado, profissionais preparados e uma cultura forte.
            </p>
            <p>
              Aqui, cada barbeiro entende que não está apenas executando um corte — está representando uma marca
              que valoriza disciplina, evolução constante e excelência em tudo o que faz.
            </p>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
              className="mt-3 inline-flex items-center rounded-full border border-cream/25 px-6 py-2.5 text-sm text-cream hover:bg-cream hover:text-[#0b0807] transition-colors"
            >
              Agendar agora
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export { SectionLabel };
export default About;
